import React, { useState } from "react";
import Layout from "../components/Layout/Layout";
import SendMail from "../components/SendMail/SendMail";
import { sendMail } from "../features/mail/mailSlice";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

const MailScreen = () => {
  const [formData, setFormData] = useState({
    subject: "",
    email: "",
    text: "",
  });

  const { subject, email, text } = formData;

  const dispatch = useDispatch();

  const { isError } = useSelector((state) => state.mail);

  const onChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (isError || !email || !text) {
      toast.error("Unable to send please input an email receiver or message.");
    } else {
      const emailData = {
        subject,
        email,
        text,
      };

      dispatch(sendMail(emailData));

      setFormData({
        subject: "",
        email: "",
        text: "",
      });

      toast.success(`Your mail sent to ${email}`);
    }
  };

  return (
    <Layout>
      <SendMail
        subject={subject}
        email={email}
        text={text}
        onChange={onChange}
        onSubmit={onSubmit}
      />
    </Layout>
  );
};

export default MailScreen;
